import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { productGroupSelectionAction } from "../../redux/actions/products/productActions";
import { apiGetProductGroups } from "../../services/ProductsService";
import ProductTreeSelector from "./ProductTreeSelector";
import iconProduct from "../../images/buttons/vyrobky.png";

import "./ProductBreadCrumb.css";
import { SelectBox } from "../common/SelectBox";
import { useTranslation } from "react-i18next";

interface Props {
  selectionOfProductIsRequired: boolean;
  hidePath?: boolean;
}

const translationPrefix = 'ProductSelection';

const ProductBreadCrumb = (props: Props) => {
  const dispatch = useDispatch();
  const [selectionOpened, setSelectionOpened] = useState(false);
  const { t } = useTranslation(undefined, { keyPrefix: translationPrefix });
  const productInfo = useSelector((state: any) => state.productInfo);
  const userInfo = useSelector((state: any) => state.userInfo);

  let initData: any[] = [];

  const [productGroups, setProductGroups] = useState(initData);
  const handleTreeSelectorCancellation = () => {
    setSelectionOpened(false);
  };

  const handleTreeSelectorProductSelection = (
    productGroup: any,
    product: any
  ) => {
    let payLoad = JSON.stringify({
      group: productGroup,
      productId: product.id,
      productGroupPath: product.groupPath,
      productPath: product.path,
      productName: product.name,
      productPrefersLitres: product.preferLitres
    });

    localStorage.setItem(`${userInfo.Username}_productInfo`, payLoad);
    dispatch(productGroupSelectionAction(payLoad));
    setSelectionOpened(false);
  };

  const handleTreeSelectorProductGroupSelection = (productGroup: any) => {
    let payLoad = JSON.stringify({
      group: productGroup,
      productId: null,
      productGroupPath: productGroup.groupPath,
      productPath: "",
      productPrefersLitres: false
    });
    localStorage.setItem(`${userInfo.Username}_productInfo`, payLoad);
    dispatch(productGroupSelectionAction(payLoad));
    setSelectionOpened(false);
  };

  const onProductBreadCrumbSelectionClick = () => {
    apiGetProductGroups(props.selectionOfProductIsRequired).then(
      (responseData) => {
        setProductGroups(responseData.data);
      }
    );

    setSelectionOpened(true);
  };

  let currentPath: any;

  let warningMessage = props.selectionOfProductIsRequired
    ? t('PleaseSelectProduct')
    : t('PleaseSelectProductGroup');

  if (props.selectionOfProductIsRequired) {
    if (productInfo && productInfo.productPath) {
      currentPath = (
        <span className="productBreadCrumbValue">
          {productInfo.productGroupPath} - <span className="productName">{productInfo.productName}</span>
        </span>
      );
    } else {
      currentPath = (
        <span className="productBreadCrumbValueEmpty">{warningMessage}</span>
      );
    }
  } else {
    if (productInfo && productInfo.group) {
      currentPath = (
        <span className="productBreadCrumbValue">{productInfo.group.path}</span>
      );
    } else {
      currentPath = (
        <span className="productBreadCrumbValueEmpty">{warningMessage}</span>
      );
    }
  }

  return (
    <div className="productBreadCrumb">

      {selectionOpened && (
        <ProductTreeSelector
          selectedGroup={productInfo.group}
          selectedProductId={productInfo.productId}
          productGroups={productGroups}
          handleCancellation={handleTreeSelectorCancellation}
          handleGroupSelection={handleTreeSelectorProductGroupSelection}
          handleProductSelection={handleTreeSelectorProductSelection}
          selectionOfProductIsRequired={props.selectionOfProductIsRequired}
        />
      )}
      {userInfo.ProductGroups && userInfo.ProductGroups.length > 0 && <><div>
        <img
          style={{ marginRight: "10px" }}
          src={iconProduct}
          className="mr-3"
        />
      </div>

        {!!!props.hidePath && <div>{currentPath}</div>}

        <div>
          <a
            className="btn btn-sm btn-primary"
            onClick={() => {
              onProductBreadCrumbSelectionClick();
            }}
            style={{ backgroundColor: " #55acee;", marginLeft: "15px" }}
            role="button"
          >
            <i className="fas fa-plus-circle me-2"></i>
            {t('SelectProduct')}
          </a>
        </div>
      </>
      }
      {
        !userInfo.ProductGroups || userInfo.ProductGroups.length === 0 && <div
          style={{ textAlign: 'center', padding: '20px' }}>
          <span style={{ color: 'red', fontWeight: 'bold' }}>
            {t('YouDoNotHaveSelectedProductCategory')}
          </span>
        </div>
      }
    </div>
  );
};

export default ProductBreadCrumb;
